"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Thread = void 0;
const react_1 = __importStar(require("react"));
const useIsomorphicLayoutEffect_1 = __importDefault(require("../../../shared/hooks/useIsomorphicLayoutEffect"));
const IntersectionObserver_1 = require("./IntersectionObserver");
const Thread_styles_1 = require("./Thread.styles");
const Thread_utils_1 = require("./Thread.utils");
const ThreadContext_1 = require("./ThreadContext");
const Body_1 = require("./components/body/Body");
const DateDivider_1 = require("./components/body/dateDivider/DateDivider");
const Item_1 = require("./components/body/item/Item");
const List_1 = require("./components/body/list/List");
const Message_1 = require("./components/body/message/Message");
const Attachment_1 = require("./components/body/message/attachment/Attachment");
const ScrollAnchor_1 = require("./components/body/scrollAnchor/ScrollAnchor");
const UnreadBadge_1 = require("./components/body/unreadBadge/UnreadBadge");
const Footer_1 = require("./components/footer/Footer");
const ActionButton_1 = require("./components/footer/actionButton/ActionButton");
const Header_1 = require("./components/header/Header");
/**
 * Wraps all of the other Thread elements it's composed of.
 */
const Thread = ({ children, }) => {
    // Here we'll store references to the top and bottom of each message that needs to be tracked, and keep track of what has been visible
    const trackedMessageRefs = (0, react_1.useRef)({});
    // Here we have the observer object used in the component, we can initialise it where convenient
    const observer = (0, react_1.useRef)();
    // Ref for auto scroll behaviour
    const scrollAnchorRef = (0, react_1.useRef)(null);
    // When tickets finish painting, start observing every ref
    (0, useIsomorphicLayoutEffect_1.default)(() => {
        if (Object.keys(trackedMessageRefs.current).length > 0) {
            // Create an observer with the populateed refs and start observing them all
            observer.current = (0, IntersectionObserver_1.initialiseObserver)(trackedMessageRefs.current, Thread_utils_1.onIntersectingTopOrBottom, Thread_utils_1.startObservingTopAndBottom);
        }
        // After we unmount, disconnect the observer completely
        return () => {
            var _a;
            (_a = observer.current) === null || _a === void 0 ? void 0 : _a.disconnect();
            trackedMessageRefs.current = {};
        };
    });
    return (react_1.default.createElement(ThreadContext_1.ThreadProvider, { value: {
            trackedMessageRefs,
            scrollAnchorRef,
        } },
        react_1.default.createElement(Thread_styles_1.StyledThread, { "data-testid": "thread" }, children)));
};
exports.Thread = Thread;
Thread.Header = Header_1.Header;
Thread.Footer = Footer_1.Footer;
Thread.ActionButton = ActionButton_1.ActionButton;
Thread.Body = Body_1.Body;
Thread.Message = Message_1.Message;
Thread.UnreadBadge = UnreadBadge_1.UnreadBadge;
Thread.DateDivider = DateDivider_1.DateDivider;
Thread.ScrollAnchor = ScrollAnchor_1.ScrollAnchor;
Thread.Attachment = Attachment_1.Attachment;
Thread.List = List_1.List;
Thread.Item = Item_1.Item;
//# sourceMappingURL=Thread.js.map